import { OrderedListOutlined } from '@ant-design/icons'
import { DownloadButton } from '@components/InventoryValuation/Costing/DownloadButton'
import { DateSkipper, Horizontal } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import { getCurrentMarket } from '@utils/general'
import { Switch } from 'antd'
import { subDays } from 'date-fns'
import moment from 'moment'
import React, { useState } from 'react'

import { formatters } from '../../../utils/intl/dateTimeFormatters'

export function ActionButtons({ isFullWidth, setIsFullWidth, onDayChange, date }) {
  const [isLoading, setIsLoading] = useState(false)
  const [showDatePicker, setShowDatePicker] = useState(false)

  const additionalFormats = [
    {
      title: 'Choose Dates',
    },
  ]

  const getDownload = async (dates) => {
    if (showDatePicker) setShowDatePicker(false)
    setIsLoading(true)
    const payload = {
      start_date: dates?.start_date
        ? moment(dates.start_date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm:ss')
        : moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm:ss'),
      end_date:
        dates?.end_date &&
        moment(dates.end_date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).format('YYYY-MM-DD HH:mm:ss'),
      market_id: getCurrentMarket(),
    }
    try {
      const resp = await api.downloadInventoryCosting(payload)
      const url = window.URL.createObjectURL(new Blob([resp.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'costing_export.xlsx')
      document.body.appendChild(link)
      link.click()
    } catch (e) {
      console.log(e)
    } finally {
      setIsLoading(false)
    }
  }
  const onDownload = (item) => {
    if (item.title === 'Choose Dates') {
      setShowDatePicker(true)
      return
    }
    getDownload()
  }

  return (
    <Horizontal gap={4} alignItems='center' className='blue-date-skipper'>
      <Switch
        checkedChildren={<OrderedListOutlined />}
        checked={!isFullWidth}
        onChange={() => setIsFullWidth(!isFullWidth)}
        defaultChecked
      />

      <DownloadButton
        additionalFormats={additionalFormats}
        onDownload={onDownload}
        isLoading={isLoading}
        showDatePicker={showDatePicker}
        setShowDatePicker={setShowDatePicker}
        getDownload={getDownload}
      />
      <Horizontal style={{ minWidth: 240 }}>
        <DateSkipper daysToSkip={1} onChange={onDayChange} format={formatters.DATE} startDate={date} />
      </Horizontal>
    </Horizontal>
  )
}
